import { merge } from 'lodash'
import contentSettings from '~/sites/shop/content.settings'

const overloadSettings = {
  events: {
    heureka: {
      shopPurchase: {
        enable: false,
      },
    },
  },
}

export default merge(contentSettings, overloadSettings)
